/*
  ============================================================
  motion.js — motion do tema + janela do WhatsApp (sem biblioteca)
  ============================================================

  1. Revelação ao rolar: [data-reveal] entra com fade + subida. Só é
     escondido quando o JS marcou <html class="motion-ok">; sem JS o
     conteúdo aparece normalmente. Três redes de segurança: observer,
     varredura por rolagem/toque/redimensionamento e um limite de tempo
     (tudo visível após 6 s). No celular nada pode ficar invisível.
  2. Manifesto palavra a palavra ([data-word-reveal]).
  3. Cabeçalho fixo: .is-scrolled quando a página desce.
  4. Janela do WhatsApp: [data-wa-open] abre o <dialog id="wa-modal">
     com a mensagem do botão; cada unidade recebe o link montado.

  Respeita prefers-reduced-motion. Só anima transform e opacity.
*/
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  /* ---------- 1. Revelação ao rolar ---------- */
  var reveals = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
  function show(el) { el.classList.add('is-visible'); }

  // O que já está na tela quando o script roda fica visível de vez, ANTES de
  // ligar a classe motion-ok: assim o hero não pisca (pintado, escondido e
  // animado de novo) e o LCP não espera a animação. Só o que está abaixo da
  // dobra entra com o reveal.
  if (!reduce) {
    var vh0 = window.innerHeight;
    // Lê todas as posições antes de escrever classes: evita um relayout por elemento.
    var rects0 = reveals.map(function (el) { return el.getBoundingClientRect(); });
    reveals.forEach(function (el, i) {
      if (rects0[i].top < vh0 * 0.95 && rects0[i].bottom > 0) { show(el); }
    });
  }
  root.classList.add(reduce ? 'motion-reduce' : 'motion-ok');

  if (reduce || !('IntersectionObserver' in window)) {
    reveals.forEach(show);
  } else {
    document.querySelectorAll('[data-reveal-stagger]').forEach(function (group) {
      var step = parseInt(group.getAttribute('data-reveal-stagger'), 10) || 60;
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.style.setProperty('--reveal-delay', Math.min(i * step, 360) + 'ms');
      });
    });
    var pending = [];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { show(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 0px 0px' });

    var vh1 = window.innerHeight;
    var rects1 = reveals.map(function (el) { return el.getBoundingClientRect(); });
    reveals.forEach(function (el, i) {
      if (rects1[i].top < vh1 * 0.95 && rects1[i].bottom > 0) { show(el); }
      else { io.observe(el); pending.push(el); }
    });

    var ticking = false;
    function sweep() {
      ticking = false;
      var vh = window.innerHeight;
      var tops = pending.map(function (el) { return el.getBoundingClientRect().top; });
      pending = pending.filter(function (el, i) {
        if (el.classList.contains('is-visible')) return false;
        if (tops[i] < vh * 0.95) { show(el); io.unobserve(el); return false; }
        return true;
      });
      if (!pending.length) stopSweep();
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }
    var evs = ['scroll', 'touchmove', 'resize', 'orientationchange'];
    evs.forEach(function (e) { window.addEventListener(e, onScroll, { passive: true }); });
    var timer = setInterval(sweep, 700);
    function stopSweep() { evs.forEach(function (e) { window.removeEventListener(e, onScroll); }); clearInterval(timer); }
    /* Limite de tempo: depois de 6 s, o que ainda não apareceu aparece sem animação */
    setTimeout(function () { pending.forEach(show); pending = []; stopSweep(); }, 6000);
  }

  /* ---------- 2. Manifesto palavra a palavra ---------- */
  document.querySelectorAll('[data-word-reveal]').forEach(function (block) {
    if (block.dataset.wordsReady) return;
    var text = block.textContent.trim().split(/\s+/);
    block.textContent = '';
    text.forEach(function (w, i) {
      var span = document.createElement('span');
      span.className = 'word';
      span.textContent = w;
      span.style.setProperty('--w', i);
      block.appendChild(span);
      block.appendChild(document.createTextNode(' '));
    });
    block.dataset.wordsReady = '1';
    if (reduce || !('IntersectionObserver' in window)) { block.classList.add('is-visible'); return; }
    var wio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { block.classList.add('is-visible'); wio.disconnect(); } });
    }, { threshold: 0.2 });
    wio.observe(block);
    setTimeout(function () { block.classList.add('is-visible'); }, 6000);
  });

  /* ---------- 3. Cabeçalho fixo ---------- */
  var header = document.querySelector('.section-header');
  if (header && 'IntersectionObserver' in window) {
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
    document.body.prepend(sentinel);
    new IntersectionObserver(function (entries) {
      header.classList.toggle('is-scrolled', !entries[0].isIntersecting);
    }).observe(sentinel);
  }

  /* ---------- 5. Contagem regressiva do cupom (uma só para o site) ---------- */
  var timers = document.querySelectorAll('[data-cupom-timer]');
  if (timers.length) {
    var cfg = timers[0];
    var tMode = cfg.getAttribute('data-mode'), tZero = cfg.getAttribute('data-zero'), tKey = cfg.getAttribute('data-key');
    var tMs = (parseInt(cfg.getAttribute('data-minutes'), 10) || 0) * 60000;
    function tRead() { try { return parseInt(localStorage.getItem(tKey), 10) || 0; } catch (e) { return 0; } }
    function tSave(v) { try { localStorage.setItem(tKey, String(v)); } catch (e) {} }
    function tEnd() {
      if (tMode === 'data') { var d = new Date(cfg.getAttribute('data-end')); return isNaN(d) ? 0 : d.getTime(); }
      var saved = tRead();
      if (!saved) { saved = Date.now() + tMs; tSave(saved); }           /* primeira visita: começa agora */
      return saved;                                                        /* visitas seguintes: nunca muda */
    }
    var tEndAt = tEnd();
    function tPad(n) { return (n < 10 ? '0' : '') + n; }
    function tHide() { timers.forEach(function (t) { t.hidden = true; t.classList.add('tc--zerado'); document.dispatchEvent(new CustomEvent('cupom-timer:zero')); }); }
    function tTick() {
      var left = tEndAt - Date.now();
      if (left <= 0) {
        if (tMode === 'evergreen' && tZero === 'reiniciar') { tEndAt = Date.now() + tMs; tSave(tEndAt); left = tMs; }
        else { tHide(); return; }
      }
      var t = Math.floor(left / 1000), h = Math.floor(t / 3600), m = Math.floor(t % 3600 / 60), sec = t % 60;
      timers.forEach(function (el) {
        el.hidden = false;
        el.querySelector('[data-t="h"]').textContent = tPad(h);
        el.querySelector('[data-t="m"]').textContent = tPad(m);
        el.querySelector('[data-t="s"]').textContent = tPad(sec);
      });
      setTimeout(tTick, 1000 - (Date.now() % 1000));
    }
    tTick();
  }

  /* ---------- 4. Janela do WhatsApp ---------- */
  /* Eventos para Meta Pixel (fbq) e GA4 (gtag), quando instalados. */
  function track(name, el) {
    var sec = el.closest('.shopify-section');
    var data = { origem: sec ? sec.id.replace('shopify-section-', '').split('__').pop() : 'flutuante', unidade: el.getAttribute('data-wa-unit') || '', pagina: location.pathname };
    try { if (window.fbq) fbq('trackCustom', name, data); } catch (e) {}
    try { if (window.gtag) gtag('event', name, data); } catch (e) {}
  }
  /* Clique num link que leva ao número de uma unidade: um evento por cidade no GA4
     (wpp_aparecida, wpp_paranaiba, wpp_chapadao). A Meta recebe o mesmo nome pelo pixel.js. */
  function slugUnidade(u) { return (u || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().split(/\s+/)[0].replace(/[^a-z0-9]/g, ''); }
  function trackUnidade(el, origem) {
    var unidade = el.getAttribute('data-wa-unit') || '', slug = slugUnidade(unidade); if (!slug) return;
    var data = { origem: origem, unidade: unidade, pagina: location.pathname };
    try { if (window.gtag) gtag('event', 'wpp_' + slug, data); } catch (e) {}
  }
  var modal = document.getElementById('wa-modal');
  if (modal) {
    var items = modal.querySelectorAll('[data-wa-number]');
    var supportsDialog = typeof modal.showModal === 'function';

    var prefixo = ((window.BellaWA || {}).prefixo || '').trim();
    function comPrefixo(m) {
      m = m || '';
      if (!prefixo || m.indexOf(prefixo) === 0) return m;
      return m ? prefixo + '\n' + m : prefixo;
    }
    function openModal(message) {
      items.forEach(function (a) {
        var msg = comPrefixo(message).replace(/\[unidade\]/g, a.getAttribute('data-wa-unit') || '');
        a.href = 'https://wa.me/' + a.getAttribute('data-wa-number') + (msg ? '?text=' + encodeURIComponent(msg) : '');
      });
      if (supportsDialog) { if (!modal.open) modal.showModal(); }
      else { modal.setAttribute('open', ''); }
      document.body.classList.add('wa-modal-open');
      var first = modal.querySelector('.wa-modal__item');
      if (first) first.focus({ preventScroll: true });
    }
    function closeModal() {
      if (supportsDialog && modal.open) modal.close(); else modal.removeAttribute('open');
      document.body.classList.remove('wa-modal-open');
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-wa-open]');
      if (trigger) { e.preventDefault(); track('whatsapp_click', trigger); ultimaOrigem = origemDe(trigger); openModal(trigger.getAttribute('data-wa-message')); return; }
      if (e.target.closest('[data-wa-close]')) { closeModal(); return; }
      if (e.target === modal) { closeModal(); } /* toque fora da caixa */
    });
    modal.addEventListener('close', function () { document.body.classList.remove('wa-modal-open'); });
    modal.addEventListener('cancel', function () { document.body.classList.remove('wa-modal-open'); });
    var ultimaOrigem = 'flutuante';
    function origemDe(el) { var s = el.closest('.shopify-section'); return s ? s.id.replace('shopify-section-', '').split('__').pop() : 'flutuante'; }
    items.forEach(function (a) { a.addEventListener('click', function () { trackUnidade(a, ultimaOrigem); setTimeout(closeModal, 300); }); });
    /* links diretos (página da unidade, plantão, farmacêutica): mesmo evento por cidade, achando a unidade pelo número */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="wa.me/"]'); if (!a || a.hasAttribute('data-wa-number') || a.hasAttribute('data-wa-open')) return;
      var m = (a.getAttribute('href') || '').match(/wa\.me\/(\d+)/), item = m && modal.querySelector('a[data-wa-number="' + m[1] + '"]');
      if (item && !a.getAttribute('data-wa-unit')) a.setAttribute('data-wa-unit', item.getAttribute('data-wa-unit') || '');
      trackUnidade(a, origemDe(a));
    }, true);
  }
})();
